import React, { useEffect, useState } from "react";
import { useAppContext } from "../../../_context";
import Button from "../../Misc/Button";
import { Col, FormControl, FormGroup, Row } from "react-bootstrap";
import { usePremiumContext } from "../../../_contextPremium";
import ErrorMessageInfo from "../../Misc/ErrorMessageInfo";
import { useRouter } from "next/router";
import { apiUrl } from "../../../utilities/Helpers";
import { events, identifyUser, track } from "../../../utilities/Analitycs";
import { errorMessages } from "./helpers/constants";
import { validateEmail } from "../../../utilities/validations";
import { experiments } from "../../../utilities/FeatureToggle";
import CustomInput from "../../Misc/CustomInput";
import HideIcon from "../../Icons/ic_hide.svg";
import ShowIcon from "../../Icons/ic_show.svg";

function UserDetails() {
  const [{ tx }] = useAppContext();
  const router = useRouter();

  const [{ userData }, setPremiumContext] = usePremiumContext();
  const [errorMessage, setErrorMessage] = useState("");
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [countryCode, setCountryCode] = useState("");
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (userData) {
      setFullName(userData.fullName);
      setEmail(userData.email);
    }
  }, [userData]);

  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((countryData) => {
        setCountryCode(countryData.country_code);
      })
      .catch((err) => console.log(err));
  }, []);

  const onSubmitUserData = async () => {
    if (!fullName || !email) {
      setErrorMessage(tx["Please fill in all the inputs"]);
      return;
    }

    if (!validateEmail(email)) {
      setErrorMessage(tx["Invalid email format"]);
      return;
    }

    if (!password || !confirmPassword) {
      setErrorMessage(tx["Please fill in all the inputs"]);
      return;
    }

    if (password !== confirmPassword) {
      setErrorMessage(tx["Password does not match"]);
      return;
    }

    if (
      password.search(/[0-9]/) === -1 ||
      password.search(/[A-Z]/) === -1 ||
      password.search(/[a-z]/) == -1 ||
      password.length < 6
    ) {
      setErrorMessage(tx["Password format invalid"]);
      return;
    }

    if (password !== confirmPassword) {
      setErrorMessage(tx["Check password confirmation"]);
      return;
    }

    const payload = {
      fullName,
      email,
      password,
    };
    getUserToken(payload);
  };

  const getUserToken = async (payload) => {
    setLoading(true);
    try {
      const res = await fetch(apiUrl("/api/v1/web/onboard"), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-version": "New",
        },
        body: JSON.stringify({
          fullName: payload.fullName,
          email: payload.email,
          password: payload.password,
          countryCode,
          priceExperiments: experiments().onboardingPriceExperiment,
        }),
      });

      const formattedResponse = await res.json();

      if (formattedResponse.token) {
        track(events.endFunnel);
        identifyUser(formattedResponse.token._id, {
          name: payload?.fullName,
          first_name: payload?.fullName?.split(" ")[0],
          email: payload?.email,
        });
        setPremiumContext((prev) => {
          return {
            ...prev,
            userToken: formattedResponse.token.token,
            userId: formattedResponse.token._id,
            userAlreadyOnboarded: formattedResponse?.onboarded,
            userData: payload,
          };
        });

        if (formattedResponse?.showPaywall) {
          router.push({
            pathname: "/find-tennis-partner/membership-plans",
            query: { player: formattedResponse.token.token },
          });
        } else {
          router.replace("/install-the-app");
        }
      } else {
        setPremiumContext((prev) => {
          return {
            ...prev,
            userToken: "",
          };
        });

        if (formattedResponse.message === errorMessages.userAlreadyRegistered) {
          setErrorMessage(tx["This account is already created"]);
          setLoading(false);
          return;
        }
        if (formattedResponse.message === errorMessages.invalidEmailFormat) {
          setErrorMessage(tx["Invalid email format"]);
          setLoading(false);
          return;
        }

        setLoading(false);
        setErrorMessage(tx["be_unexpected_error"]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="premium-location-container py-6 px-md-7 px-4">
        <Row>
          <FormGroup className="mb-3">
            <label className="form-label" htmlFor="premium-full-name">
              {tx["Full name"]} *
            </label>
            <FormControl
              id="premium-full-name"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
            />
          </FormGroup>
        </Row>
        <Row>
          <Col md={12}>
            <FormGroup className="mb-3">
              <label className="form-label" htmlFor="premium-email">
                {tx["Email"]} *
              </label>
              <FormControl
                id="premium-email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            <CustomInput
              id="set-password"
              label={tx["Password"]}
              icon={showPassword ? <ShowIcon /> : <HideIcon />}
              iconClick={() => setShowPassword((prev) => !prev)}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type={showPassword ? "text" : "password"}
              className="mb-3"
            />
          </Col>
          <Col lg={6}>
            <CustomInput
              id="confirm-password"
              label={tx["Password confirmation"]}
              icon={showConfirmPassword ? <ShowIcon /> : <HideIcon />}
              iconClick={() => setShowConfirmPassword((prev) => !prev)}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              type={showConfirmPassword ? "text" : "password"}
              className="mb-3"
            />
          </Col>
          <p className="secondary-text">
            {
              tx[
                "The password needs to have at least 6 characters and include uppercase letters, lowercase letters and numbers."
              ]
            }
          </p>
        </Row>
      </div>
      {errorMessage && (
        <div className="mt-4">
          <ErrorMessageInfo>{errorMessage}</ErrorMessageInfo>
        </div>
      )}
      <div
        className={`d-flex align-items-center justify-content-center my-4 ${
          errorMessage ? "SubmitButton--error" : ""
        }`}>
        <Button
          onClick={onSubmitUserData}
          isLoading={loading}
          disabled={loading}>
          {tx["Create"]}
        </Button>
      </div>
    </>
  );
}

export default UserDetails;
